import React from 'react';
import PropTypes from 'prop-types';

const LoadingLine = ({ style, className, loading }) => {
  const bounceStyle = {
    backgroundColor: '#111',
    position: 'relative',
    top: '40%'
  };

  const bounceContainer = {
    textAlign: 'center',
    height: '100px'
  };

  if (!loading) return null;

  return (
    <div
      className={`btn--wide btn--loading ${className}`}
      style={{ ...bounceContainer, ...style }}
      data-testid='loadingLine'
    >
      <div className='bounce bounce1' style={bounceStyle} />
      <div className='bounce bounce2' style={bounceStyle} />
      <div className='bounce bounce3' style={bounceStyle} />
    </div>
  );
};

LoadingLine.defaultProps = {
  loading: true
};

LoadingLine.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  loading: PropTypes.bool
};

export default LoadingLine;
